import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Reveal from "@/components/Reveal";

export default function ContactPage() {
  const formRef = useRef(null);
  const [status, setStatus] = useState("idle");

  const sendEmail = (e) => {
    e.preventDefault();
    if (!formRef.current || status === "sending") return;

    setStatus("sending");
    emailjs
      .sendForm("service_urqfvso", "template_3beppzr", formRef.current, {
        publicKey: "XNNRPSKz73F-RaqY_",
      })
      .then(() => {
        setStatus("sent");
        formRef.current.reset();
        setTimeout(() => setStatus("idle"), 2800);
      })
      .catch(() => {
        setStatus("error");
        setTimeout(() => setStatus("idle"), 3200);
      });
  };

  return (
    <section className="contact" style={{ paddingTop: "calc(var(--nav-h) + 3rem)" }}>
      <div className="wrap contact__panel">
        <Reveal>
          <p className="eyebrow">Contact</p>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(2.2rem, 5vw, 3.6rem)", letterSpacing: "-0.045em", lineHeight: 0.98, margin: "0.75rem 0 1rem" }}>
            Start a project
          </h1>
          <p>
            Share the problem, desired outcome, current stack, and timing. This form will later connect to the Rails
            marketing and email backend — EmailJS is wired for now.
          </p>
        </Reveal>

        <Reveal as="form" className="form" ref={formRef} onSubmit={sendEmail}>
          <div className="form__row">
            <div className="field">
              <label htmlFor="user_name">Name</label>
              <input id="user_name" name="user_name" type="text" autoComplete="name" required placeholder="Alex Rivera" />
            </div>
            <div className="field">
              <label htmlFor="user_email">Email</label>
              <input
                id="user_email"
                name="user_email"
                type="email"
                autoComplete="email"
                required
                placeholder="alex@company.com"
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="focus">Focus</label>
            <select id="focus" name="focus" defaultValue="ecommerce">
              <option value="ecommerce">Ecommerce</option>
              <option value="saas">SaaS</option>
              <option value="ai">AI</option>
              <option value="mixed">Mixed / not sure</option>
            </select>
          </div>
          <div className="field">
            <label htmlFor="message">Project brief</label>
            <textarea id="message" name="message" rows={5} required placeholder="What are you trying to ship, and by when?" />
          </div>
          <button className="btn" type="submit" disabled={status === "sending"}>
            {status === "sending" && "Sending…"}
            {status === "sent" && "Received — we’ll be in touch"}
            {status === "error" && "Something went wrong — try again"}
            {status === "idle" && "Send inquiry"}
          </button>
          <p className="form__note">No spam. One reply with a clear next step.</p>
        </Reveal>
      </div>
    </section>
  );
}
